.bi{padding:0.5rem;}